module.exports = __webpack_public_path__ + "assets/img/dialog-bg@2x.9d884a6a.png";